/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : helper.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

const helper = {
  getObjectKeyByValue: (object, value) => {
    if (!object || typeof object !== "object") {
      return "-";
    }

    const key = Object.keys(object)?.find((k) => object?.[k] === value);
    return key ? key.replaceAll("_", " ") : "-";
  },
  getValueByKey: (array, key) => {
    if (!Array.isArray(array)) return "-";
    const result = array.find((item) => item?.key === key);
    return result ? result.value : "-";
  },
  convertKeyValueToLabel: (array) => {
    if (!Array.isArray(array)) {
      return [];
    }

    return array?.map((item) => ({
      value: item.key,
      label: item.value,
    }));
  },
  convertKeyValueToLabelFiltered: (array, removeList) => {
    if (!Array.isArray(array)) {
      return [];
    }

    const safeRemoveList = Array.isArray(removeList) ? removeList : [];

    return array
      ?.filter(
        (item) => item?.key !== undefined && !safeRemoveList.includes(item?.key)
      )
      ?.map((item) => ({
        value: item.key,
        label: item.value,
      }));
  },
  getUserDetailsByIds: (usersDetailsList, userIds) => {
    if (!Array.isArray(usersDetailsList) || !Array.isArray(userIds)) {
      return [];
    }

    return usersDetailsList?.filter((user) => userIds?.includes(user?.user_id));
  },
  truncate: (str, max = 8) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "..." : str;
  },
  toSentenceCase: (text = "") => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },
};

export default helper;
